import { DEFAULT_BORDER } from 'constants/global';

import Secuer from 'assets/icons/secuer.svg';
import Architer from 'assets/icons/architer.svg';
import Edit from 'assets/icons/edit.svg';
import Reward from 'assets/icons/reward.svg';
import Fire from 'assets/icons/fire.svg';
import PC from 'assets/icons/pc.svg';

const boxSize = {
  boxSize: 'unset',
  w: { mobile: 'full', xm: '340px', laptop: '600px', desktop: '670px' },
  minH: { mobile: '340px', laptop: '440px', desktop: '600px' },
  p: { mobile: '60px 24px 24px', laptop: '0 48px 48px' },
};

export const dedicatedTeamExpertiseCardsSliderData = {
  title: (
    <>
      Когда нужна выделенная <br /> команда
    </>
  ),
  cardsData: [
    {
      src: Secuer,
      title: 'Снизить риски на долгосрочном проекте',
      text: 'Чтобы сократить риски на длительных проектах, более целесообразно нанять выделенную команду разработчиков, которая станет вашим стратегическим партнёром на весь срок проекта.',
      sx: { bgColor: 'bg.neonLight', ...boxSize },
    },
    {
      src: Architer,
      iconProps: { bgColor: 'bg.gray' },
      title: 'Сохранить контроль за разработкой',
      text: 'Вы принимаете все ключевые решения по проекту. При этом специалисты выделенной команды предлагают идеи, которые позволят усилить проект, а в перспективе и ваш бизнес.',
      sx: { bgColor: 'bg.white', border: DEFAULT_BORDER, borderColor: 'bg.gray', ...boxSize },
    },
    {
      src: Edit,
      title: 'Нет чётких требований и плана',
      text: 'Отсутствие чёткого плана реализации и размытые требования угрожают успеху вашего проекта. Предусмотреть риски поможет выделенная команда.',
      sx: { bgColor: 'bg.gray', ...boxSize },
    },
    {
      src: Reward,
      title: 'Нужна узкая экспертиза',
      text: 'Довольно часто сложные ИТ-проекты требуют особых компетенций, направленных на конкретную задачу. Выделенная команда разработчиков, сформированная с нашей помощью, устранит этот пробел.',
      sx: { bgColor: 'bg.grayLight', ...boxSize },
    },
    {
      src: Fire,
      title: 'Усилить собственную команду',
      text: 'Для реализации ИТ-проекта, как правило, применяется несколько технологий. Разработчики в выделенной команде владеют всеми необходимыми инструментами и работают под вашим контролем.',
      sx: { bgColor: 'bg.neonLight', ...boxSize },
    },
    {
      src: PC,
      title: 'Создание первой версии (MVP)',
      text: 'Для создания успешного MVP необходимы чёткое понимание целей и высокая скорость работы. Лучший способ обеспечить эти показатели — сотрудничать с высококвалифицированной командой разработчиков.',
      sx: { bgColor: 'bg.white', border: DEFAULT_BORDER, borderColor: 'bg.gray', ...boxSize },
    },
  ],
};
